import { render, staticRenderFns } from "./HostDashboardEventDetails.vue?vue&type=template&id=41013332&"
import script from "./HostDashboardEventDetails.vue?vue&type=script&lang=js&"
export * from "./HostDashboardEventDetails.vue?vue&type=script&lang=js&"
import style0 from "./HostDashboardEventDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HostDashboardEventDetails.vue"
export default component.exports